module.exports = __webpack_public_path__ + "static/media/greencheck.28f31c6a.svg";